const TRIAL_ENDING_SOON_MS = 30 * 24 * 60 * 60 * 1000;

export const isTrialEndingSoon = (endAt: string | null, now = Date.now()): boolean => {
  if (!endAt) return false;
  const remaining = new Date(endAt).getTime() - now;
  return remaining > 0 && remaining < TRIAL_ENDING_SOON_MS;
};
